import { Grid, Paper } from '@mui/material';
import React from 'react';
import CAppPaper from '../../../../../app/components/CAppPaper';
import CAppSubTitle from '../../../../../app/components/CAppSubTitle';

const CTestUiPapers = () => {
	return (
		<>
			<CAppSubTitle title="Variant & Square" />
			<Grid container spacing={3}>
				<Grid item sm={3}>
					<Paper variant="elevation">Variant - Elevation</Paper>
				</Grid>
				<Grid item sm={3}>
					<Paper variant="elevation" square>
						Variant - Elevation - Square
					</Paper>
				</Grid>
				<Grid item sm={3}>
					<Paper variant="outlined">Variant - Outlined</Paper>
				</Grid>
				<Grid item sm={3}>
					<Paper variant="outlined" square>
						Variant - Outlined - Square
					</Paper>
				</Grid>
			</Grid>
			<CAppSubTitle title="CAppPaper" subtitle="Elevation" />
			<Grid container spacing={3}>
				<Grid item sm={2}>
					<CAppPaper variant="elevation">Default</CAppPaper>
				</Grid>
				<Grid item sm={2}>
					<CAppPaper variant="elevation" displayBackgroundImage>
						Default - BG
					</CAppPaper>
				</Grid>
				<Grid item sm={2}>
					<CAppPaper variant="elevation" color="primary">
						Primary
					</CAppPaper>
				</Grid>
				<Grid item sm={2}>
					<CAppPaper variant="elevation" color="primary" displayBackgroundImage>
						Primary - BG
					</CAppPaper>
				</Grid>
				<Grid item sm={2}>
					<CAppPaper variant="elevation" color="secondary">
						Secondary
					</CAppPaper>
				</Grid>
				<Grid item sm={2}>
					<CAppPaper variant="elevation" color="secondary" displayBackgroundImage>
						Secondary - BG
					</CAppPaper>
				</Grid>
			</Grid>
			<CAppSubTitle title="CAppPaper" subtitle="Outlined" />
			<Grid container spacing={3}>
				<Grid item sm={2}>
					<CAppPaper variant="outlined">Default</CAppPaper>
				</Grid>
				<Grid item sm={2}>
					<CAppPaper variant="outlined" displayBackgroundImage>
						Default - BG
					</CAppPaper>
				</Grid>
				<Grid item sm={2}>
					<CAppPaper variant="outlined" color="primary">
						Primary
					</CAppPaper>
				</Grid>
				<Grid item sm={2}>
					<CAppPaper variant="outlined" color="primary" displayBackgroundImage>
						Primary - BG
					</CAppPaper>
				</Grid>
				<Grid item sm={2}>
					<CAppPaper variant="outlined" color="secondary">
						Secondary
					</CAppPaper>
				</Grid>
				<Grid item sm={2}>
					<CAppPaper variant="outlined" color="secondary" displayBackgroundImage>
						Secondary - BG
					</CAppPaper>
				</Grid>
			</Grid>
			<CAppSubTitle title="CAppPaper" subtitle="with Title & icone" />
			<Grid container spacing={3}>
				<Grid item sm={2}>
					<CAppPaper variant="outlined" title="Title" icon="user_settings">
						Default
					</CAppPaper>
				</Grid>
				<Grid item sm={2}>
					<CAppPaper variant="outlined" title="Title" icon="user_settings" displayBackgroundImage>
						Default - BG
					</CAppPaper>
				</Grid>
				<Grid item sm={2}>
					<CAppPaper variant="outlined" color="primary" title="Title" icon="user_settings">
						Primary
					</CAppPaper>
				</Grid>
				<Grid item sm={2}>
					<CAppPaper
						variant="outlined"
						color="primary"
						title="Title"
						icon="user_settings"
						displayBackgroundImage
					>
						Primary - BG
					</CAppPaper>
				</Grid>
				<Grid item sm={2}>
					<CAppPaper variant="outlined" color="secondary" title="Title" icon="user_settings">
						Secondary
					</CAppPaper>
				</Grid>
				<Grid item sm={2}>
					<CAppPaper
						variant="outlined"
						color="secondary"
						title="Title"
						icon="user_settings"
						displayBackgroundImage
					>
						Secondary - BG
					</CAppPaper>
				</Grid>
			</Grid>
		</>
	);
};

export default CTestUiPapers;
